<section class="loading_screen">
    <img src="https://storage.googleapis.com/miles-next_website-lms-gptool/LMS-2024/Gameplan-Status/giftAnimationLoading.gif"
        class="img-fluid">
</section>